// extracted by mini-css-extract-plugin
export default {"trailsText":"styles_trailsText__btAR6","container":"styles_container__Vy2uM"};